import axios from 'axios';

const API_BASE = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:5001/api'
  : '/api';

export const dealersApi = {
  // Get all dealers (public)
  getAll: async () => {
    const response = await axios.get(`${API_BASE}/dealers`);
    return response.data;
  },

  // Get all dealers including inactive (admin)
  getAdminDealers: async (token) => {
    const response = await axios.get(`${API_BASE}/admin/dealers`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Create new dealer (admin)
  create: async (dealer, token) => {
    const response = await axios.post(`${API_BASE}/admin/dealers`, dealer, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Update dealer (admin)
  update: async (id, dealer, token) => {
    const response = await axios.put(`${API_BASE}/admin/dealers/${id}`, dealer, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Delete dealer (admin)
  delete: async (id, token) => {
    const response = await axios.delete(`${API_BASE}/admin/dealers/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Geocode address to get lat/lng
  geocodeAddress: async (address, city, state, zipCode) => {
    const fullAddress = `${address}, ${city}, ${state} ${zipCode}, USA`;
    
    try {
      // Use OpenStreetMap Nominatim for geocoding (free, no API key required)
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search`,
        {
          params: {
            q: fullAddress,
            format: 'json',
            limit: 1,
            countrycodes: 'us'
          },
          headers: {
            'User-Agent': 'Centurion-Boat-Dealers/1.0'
          }
        }
      );

      if (response.data && response.data.length > 0) {
        return {
          latitude: parseFloat(response.data[0].lat),
          longitude: parseFloat(response.data[0].lon),
          displayName: response.data[0].display_name
        };
      }
      
      return null;
    } catch (error) {
      console.error('Geocoding error:', error);
      return null;
    }
  }
};

export default dealersApi;



